module.exports = __webpack_public_path__ + "media/images/admin/icons/download-6a87135582202029736f1b76716b2fec.svg";